<script lang="ts" setup>
import { useGlobalUser } from "@/stores/globalUser";
import { onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import NSFWModalConfirmAgeLogin from "@/views/NSFW/Modal/NSFWModalConfirmAgeLogin.vue";
import { useRouteQuery } from "@vueuse/router";
import api from "@/modules/api";
import { Mate } from "@/types/entity";
import { HOME_ROUTER } from "@/use/go";

const userStore = useGlobalUser();
const router = useRouter();
const route = useRoute();
const loginContainer = ref<HTMLDivElement | null>(null);
const morningBgUrl = "/img/login/4-9.webp";
const afternoonBgUrl = "/img/login/9-16.webp";
const eveningBgUrl = "/img/login/16-20.webp";
const nightBgUrl = "/img/login/20-4.webp";

const mode = useRouteQuery<"" | "login" | "register">("mode", "");
const isCN = !!import.meta.env.VITE_IS_CN;
const year = new Date().getFullYear();
const getBackgroundUrl = () => {
  const hour = new Date().getHours();
  if (hour >= 4 && hour < 9) {
    return morningBgUrl;
  } else if (hour >= 9 && hour < 16) {
    return afternoonBgUrl;
  } else if (hour >= 16 && hour < 20) {
    return eveningBgUrl;
  } else {
    return nightBgUrl;
  }
};

watch(
  mode,
  (newMode) => {
    console.log(newMode);
  },
  { immediate: true }
);

// Methods
async function redirectAfterLogin() {
  console.log("redirectAfterLogin");
  if (route.query.from === "webGal") {
    window.opener.postMessage(
      "loginSuccess",
      import.meta.env.VITE_GAL_GAME_URL
    );
    window.close();
  } else if (route.query.redirect) {
    await router.push(route.query.redirect as string);
  } else {
    console.log("redirectAfterLogin, to threads");
    await router.push(HOME_ROUTER);
  }
}

const onModeChange = (
  newMode: "" | "login" | "register",
  _isLogin: boolean
) => {
  userStore.loginModal.type = _isLogin ? "login" : "register";
  mode.value = newMode;
};

// 弹框年龄
const showConfirmAge = ref(false);
const onAgeConfirm = () => {
  showConfirmAge.value = false;
  redirectAfterLogin();
};

const inviter = ref<Mate | null>(null);

onMounted(() => {
  if (userStore.isLogin) {
    if (route.query.redirect) {
      if (route.query.redirect === "/") {
        router.replace(HOME_ROUTER);
      } else {
        router.push(route.query.redirect as string);
      }
    } else router.replace(HOME_ROUTER);
    return;
  }

  if (route.query.code) {
    api
      .UserInvitationCodeCheck({ code: route.query.code as string })
      .then((res) => {
        inviter.value = res.data.inviter;
      });
  }
});
</script>
<template>
  <div
    ref="loginContainer"
    class="h-full grid grid-rows-[1fr] bg-cover relative bg-bottom bg-no-repeat text-white text-shadow"
    crossorigin="anonymous"
  >
    <img
      class="absolute top-0 left-0 bottom-0 right-0 object-cover object-bottom w-full h-full"
      :src="getBackgroundUrl()"
      alt=""
      crossorigin="anonymous"
    />
    <!-- <transition name="fade">
      <div
        v-if="mode"
        class="bg-black/50 absolute top-0 left-0 right-0 bottom-0"
      ></div>
    </transition> -->
    <!-- Nav -->
    <div
      class="w-full h-full flex flex-col justify-between items-center relative z-10 py-8 px-4 xs:px-8 overflow-hidden"
    >
      <button
        class="btn btn-ghost absolute top-0 right-0"
        @click="router.push(HOME_ROUTER)"
      >
        {{ $t("Buttons.cancel") }}
      </button>
      <div class="w-full h-full relative overflow-auto">
        <div
          class="h-full px-4 md:px-8 pt-10 flex flex-col justify-between relative z-10"
        >
          <div class="flex flex-col justify-center items-center">
            <LogoIcon class="w-48" />
          </div>
          <div
            v-if="!mode"
            class="flex flex-col gap-2 items-center justify-center"
          >
            <!-- <button
              class="btn btn-primary rounded w-full"
              @click="onModeChange('register', false)"
            >
              {{ $t("loginmodal.register") }}
            </button> -->
            <button
              class="btn btn-primary rounded w-full"
              @click="router.push({ name: 'mateCreate' })"
            >
              {{ $t("loginmodal.register") }}
            </button>
            <button
              class="btn border-0 bg-white text-primary rounded w-full hover:bg-gray-200"
              @click="onModeChange('login', true)"
            >
              {{ $t("loginmodal.hasAccount") }}
            </button>
          </div>
          <div v-else>
            <div v-if="inviter" class="text-center mb-4">
              <img
                :src="inviter.mediaUrl"
                class="w-4 h-4 rounded-full inline-block"
                crossorigin="anonymous"
              />
              <span class="pr-2 pl-1">{{ inviter.name }}</span>
              <span class="whitespace-pre-wrap text-gray-300">
                {{ $t("invitation.inviteYou") }}
              </span>
            </div>
            <div class="text-center font-bold text-2xl pb-8">
              {{ mode === "login" ? $t("User.login") : $t("User.register") }}
            </div>
            <user-login
              class="justify-center items-center"
              theme="light"
              @login-success="redirectAfterLogin()"
            />
          </div>

          <div class="flex flex-col gap-2 items-center justify-center">
            <div v-if="isCN" class="text-shadow text-center">
              <div>京ICP备2025113882号</div>
              <p>{{ "@" + year }} 饼次元</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 年龄限制 -->
    <NSFWModalConfirmAgeLogin
      v-model:show="showConfirmAge"
      @enter="onAgeConfirm"
    />
  </div>
</template>
<style>
.input-field.van-cell {
  border: 0;
  padding: 0;
}

.input-field.van-cell::after {
  display: none;
}

.input-field .van-field__body {
  @apply input input-bordered w-full rounded;
}
</style>
